@let isSubmitting =
  surveyAdminsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-add-survey-admin-modal">
    <atn-ds-widget title="Add Survey Admin">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-add-survey-admin-modal__content">
        <atn-ds-select-single
          label="Users"
          [items]="userSelectItemsSg()"
          [value]="selectedUserIdSg()"
          [required]="true"
          (valueChange)="selectedUserChangedHandler($event)"
          placeholder="Select user"
        />
      </div>

      <div
        class="atn-space-add-survey-admin-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [disabled]="!selectedUserIdSg()"
          [loading]="isSubmitting"
          (click)="saveClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
